import EntityList from "./entity-list";

function EntityAuditDashboard() {
  return <EntityList />;
}

export default EntityAuditDashboard;
